import React from 'react';
import { Package } from 'lucide-react';
import SectionShipmentRequests from '../SectionShipmentRequests';

const FOBShipmentRequests = () => {
  return (
    <SectionShipmentRequests 
      sectionName="FOB"
      sectionIcon={Package}
      backRoute="/sections/fob"
    />
  );
};

export default FOBShipmentRequests;
